var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row align-items-end address-wrapper small-gutters",
      class: _vm.containerClass,
    },
    [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c(
            "label",
            {
              staticClass:
                "form-title form-title mb-0 text-secondary address-label",
              class: _vm.removable ? "form-title-removable" : "",
            },
            [
              _c("span", { staticStyle: { display: "none" } }, [
                _vm._v("nodisplay"),
              ]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.titleValue(_vm.index)) +
                  "\n\n        "
              ),
              !_vm.editVisibility
                ? [
                    _vm.index > 0 && !_vm.disabled
                      ? _c(
                          "span",
                          [
                            _c("inline-prompt", {
                              ref: "prompt",
                              staticClass: "bold text-gray d-inline-block",
                              attrs: {
                                "action-type": "delete",
                                "confirmation-text":
                                  _vm.$t("global.messages.allDataWillBeLost") +
                                  ":",
                              },
                              on: {
                                accept: function ($event) {
                                  return _vm.removeAddress(_vm.index)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.replicate &&
                    _vm.index === 0 &&
                    !_vm.isMirror &&
                    !_vm.forceMirror
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "text-primary ml-4 replicate-section d-block d-md-inline",
                            class: { disabled: _vm.disabled },
                            staticStyle: { cursor: "pointer" },
                            attrs: { "data-replicate": _vm.replicate },
                            on: { click: _vm.replicateAddress },
                          },
                          [_vm._v(_vm._s(_vm.replicateText))]
                        )
                      : _vm.forceMirror || _vm.isMirror
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "text-primary ml-4 replicate-section d-block d-md-inline",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.successReplicatedText) +
                                "\n            "
                            ),
                            _c("i", {
                              staticClass: "icon fa fa-check text-primary",
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.index !== 0 && _vm.displaySetAsCurrent
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "text-primary ml-4 replicate-section d-block d-md-inline",
                            staticStyle: { cursor: "pointer" },
                            on: { click: _vm.handleChangeAddressToCurrent },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("application.setAsCurrentAddress"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("address-layout", {
            scopedSlots: _vm._u([
              {
                key: "autocomplete",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "position-relative" },
                      [
                        _vm.showLabels
                          ? _c(
                              "h6",
                              { staticClass: "form-title font-sm mb-0" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("global.doorr.addressLookup")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("autocomplete-section", {
                          ref: "autoCompleteSection",
                          staticClass: "mb-0",
                          attrs: {
                            disabled: _vm.disabled,
                            placeholder: _vm.$t(
                              "global.doorr.addressLookupType"
                            ),
                            tabindex: _vm.tabindex,
                            "class-name": _vm.lookupClass,
                            "auto-fill": "off",
                            "auto-complete": "off",
                            label: _vm.$t("global.doorr.addressLookup"),
                            "hidden-label": "",
                          },
                          on: { change: _vm.handleAddressAutocompleteChange },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            attrs: { for: "autocomplete-address", hidden: "" },
                          },
                          [_vm._v("Autocomplete")]
                        ),
                        _vm._v(" "),
                        !_vm.editVisibility
                          ? [
                              _vm.enableGoogleMaps
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "open-window-popover",
                                          rawName: "v-open-window-popover",
                                          value: {
                                            url: _vm.openGoogleMaps,
                                            width: 900,
                                            height: 600,
                                          },
                                          expression:
                                            "{\n                url: openGoogleMaps,\n                width: 900,\n                height: 600\n              }",
                                        },
                                      ],
                                      key: _vm.openGoogleMaps,
                                      staticClass:
                                        "google-maps-street-view-link clickable",
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "google-maps-icon",
                                        attrs: {
                                          src: require("@Shared/@Assets/icon/google-maps-icon.svg"),
                                          alt: "doorr-google-maps-icon",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm.googleMaps
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip",
                                          value: {
                                            title: _vm.$t(
                                              "global.messages.googleMapStreetViewHintToEnable"
                                            ),
                                          },
                                          expression:
                                            "{\n                title: $t('global.messages.googleMapStreetViewHintToEnable')\n              }",
                                        },
                                      ],
                                      staticClass:
                                        "google-maps-street-view-link google-maps-icon-disabled",
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "google-maps-icon",
                                        attrs: {
                                          src: require("@Shared/@Assets/icon/google-maps-icon.svg"),
                                          alt: "doorr-google-maps-icon",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "line1",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.addressLine")) +
                              " 1\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      ref: "line1",
                      staticClass: "mb-0",
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[line1]"),
                        "label-for": _vm._f("hashId")(_vm.path + "[line1]"),
                        label: "addressLine1",
                        value: _vm.address["line1"],
                        disabled: _vm.disabled,
                        name: "line1",
                        "max-length": _vm.maxLengthValidationsToUse["line1"],
                        "class-name": "main-address " + _vm.className,
                        "auto-fill": "off",
                        "auto-complete": "off",
                        "error-message": _vm.errorMessages["line1"],
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.doorr.addressLine") + " 1",
                        tabindex: _vm.tabindex,
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "unit-number",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.unitNumber")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      staticClass: "mb-0",
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[unit-number]"),
                        "label-for": _vm._f("hashId")(
                          _vm.path + "[unit-number]"
                        ),
                        label: "unit-number",
                        value: _vm.address["unit-number"],
                        disabled: _vm.disabled,
                        name: "unit-number",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.doorr.unitNumber"),
                        "class-name": "unit_number",
                        tabindex: _vm.tabindex,
                        "max-length":
                          _vm.maxLengthValidationsToUse["unitNumber"],
                        "error-message": _vm.errorMessages["unit-number"],
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "street-number",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.streetNumber")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      staticClass: "mb-0",
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[street-number]"),
                        "label-for": _vm._f("hashId")(
                          _vm.path + "[street-number]"
                        ),
                        label: "street-number",
                        value: _vm.address["street-number"],
                        disabled: _vm.disabled,
                        name: "street-number",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.doorr.streetNumber"),
                        tabindex: _vm.tabindex,
                        "max-length":
                          _vm.maxLengthValidationsToUse["streetNumber"],
                        "class-name": "street_number " + _vm.className,
                        "error-message": _vm.errorMessages["street-number"],
                        "auto-fill": "off",
                        "auto-complete": "off",
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "street-name",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.streetName")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      staticClass: "mb-0",
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[street-name]"),
                        "label-for": _vm._f("hashId")(
                          _vm.path + "[street-name]"
                        ),
                        label: "street-name",
                        value: _vm.address["street-name"],
                        disabled: _vm.disabled,
                        name: "street-name",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.doorr.streetName"),
                        tabindex: _vm.tabindex,
                        "max-length":
                          _vm.maxLengthValidationsToUse["streetName"],
                        "class-name": "route " + _vm.className,
                        "error-message": _vm.errorMessages["street-name"],
                        "auto-fill": "off",
                        "auto-complete": "off",
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "street-direction",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.streetDirection")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      staticClass: "mb-0",
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[street-direction]"),
                        "label-for": _vm._f("hashId")(
                          _vm.path + "[street-direction]"
                        ),
                        label: "street-direction",
                        value: _vm.address["street-direction"],
                        disabled: _vm.disabled,
                        name: "street-direction",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.doorr.streetDirection"),
                        tabindex: _vm.tabindex,
                        "max-length":
                          _vm.maxLengthValidationsToUse["streetDirection"],
                        "class-name": "street-direction",
                        "error-message": _vm.errorMessages["street-direction"],
                        "auto-fill": "off",
                        "auto-complete": "off",
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "line2",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.addressLine")) +
                              " 2\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      staticClass: "mb-0",
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[line2]"),
                        "label-for": _vm._f("hashId")(_vm.path + "[line2]"),
                        label: "addressline2",
                        value: _vm.address["line2"],
                        disabled: _vm.disabled,
                        name: "line2",
                        "class-name": "line2",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.doorr.addressLine") + " 2",
                        tabindex: _vm.tabindex,
                        "max-length": _vm.maxLengthValidationsToUse["line2"],
                        "error-message": _vm.errorMessages["line2"],
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "street-type",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.streetType")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      staticClass: "mb-0",
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[street-type]"),
                        "label-for": _vm._f("hashId")(
                          _vm.path + "[street-type]"
                        ),
                        label: "street-type",
                        value: _vm.address["street-type"],
                        disabled: _vm.disabled,
                        name: "street-type",
                        "class-name": "street-type",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.doorr.streetType"),
                        tabindex: _vm.tabindex,
                        "max-length":
                          _vm.maxLengthValidationsToUse["streetType"],
                        "error-message": _vm.errorMessages["streetType"],
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "city",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.words.city")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("text-section", {
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[city]"),
                        "label-for": _vm._f("hashId")(_vm.path + "[city]"),
                        label: "city",
                        value: _vm.address["city"],
                        disabled: _vm.disabled,
                        name: "city",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.words.city"),
                        "class-name": "locality " + _vm.className,
                        tabindex: _vm.tabindex,
                        "max-length": _vm.maxLengthValidationsToUse["city"],
                        "error-message": _vm.errorMessages["city"],
                        "append-validator-path": "",
                      },
                      on: { change: _vm.eventAdapter },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "province",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.words.province")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("select-section", {
                      attrs: {
                        id: _vm._f("hashId")(_vm.path + "[province]"),
                        disabled: _vm.disabled,
                        name: "province",
                        placeholder: _vm.showLabels
                          ? ""
                          : _vm.$t("global.words.province"),
                        options: _vm.provinceOptions,
                        "container-class": _vm.time ? "mb-0" : "",
                        tabindex: _vm.tabindex,
                        "class-name":
                          "administrative_area_level_1 " + _vm.className,
                        "error-message": _vm.errorMessages["province"],
                        "append-validator-path": "",
                      },
                      nativeOn: {
                        change: function ($event) {
                          return _vm.eventAdapter.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.address["province"],
                        callback: function ($$v) {
                          _vm.$set(_vm.address, "province", $$v)
                        },
                        expression: "address['province']",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "postal-code",
                fn: function () {
                  return [
                    _vm.showLabels
                      ? _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.doorr.postalCode")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group-material form-group-material-no-label",
                        class: { "mb-0": _vm.time },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: {
                                mask: "a9a 9a9",
                                greedy: true,
                                showMaskOnHover: false,
                              },
                              expression:
                                "{ mask: 'a9a 9a9', greedy: true, showMaskOnHover: false }",
                            },
                          ],
                          staticClass:
                            "postal_code form-control forms-validation-deprecated",
                          attrs: {
                            id: _vm._f("hashId")(_vm.path + "[postal-code]"),
                            disabled: _vm.disabled,
                            pattern:
                              "([A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]){0,1}",
                            title: "",
                            maxlength: "7",
                            "data-parsley-error-message": _vm.$t(
                              "global.messages.invalidCanadianPostalCode"
                            ),
                            type: "text",
                            name: "postal-code",
                            placeholder: _vm.showLabels
                              ? ""
                              : _vm.$t("global.doorr.postalCode"),
                            tabindex: _vm.tabindex,
                            "validator-context": _vm.$v,
                          },
                          domProps: { value: _vm.address["postal-code"] },
                          on: { input: _vm.eventAdapter },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            attrs: {
                              for: _vm._f("hashId")(_vm.path + "[postal-code]"),
                              hidden: "",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.doorr.postalCode")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _vm.postalInvalid
                          ? _c(
                              "span",
                              { staticClass: "invalid-feedback d-block" },
                              [
                                _c("div", { staticClass: "invalid-icon" }, [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: {
                                          title: _vm.$t(
                                            "global.messages.invalidCanadianPostalCode"
                                          ),
                                          disabled: !_vm.showTooltipMessage,
                                        },
                                        expression:
                                          "{\n                  title: $t('global.messages.invalidCanadianPostalCode'),\n                  disabled: !showTooltipMessage\n                }",
                                      },
                                    ],
                                    staticClass: "fa fa-exclamation-circle",
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("ul", [
                                  _c(
                                    "li",
                                    { staticClass: "parsley-required" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "global.messages.invalidCanadianPostalCode"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.time
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _vm.showLabels
                ? _c("h6", { staticClass: "form-title" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("application-form.time-at-residence")) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("years-months-section", {
                staticClass: "small-gutters",
                attrs: {
                  id: _vm._f("hashId")(_vm.path + "[time-at]"),
                  name: "time-at",
                  "append-validator-path": "",
                  path: _vm.path,
                  tabindex: _vm.tabindex,
                  disabled: _vm.disabled,
                  "class-name": "time-at-residence " + _vm.className,
                },
                model: {
                  value: _vm.address["time-at"],
                  callback: function ($$v) {
                    _vm.$set(_vm.address, "time-at", $$v)
                  },
                  expression: "address['time-at']",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.map
        ? _c(
            "div",
            { staticClass: "col-12 mt-4" },
            [
              _c("google-map-wrapper", {
                attrs: { geolocation: _vm.geolocation },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }